import { render } from "./MaterialBlock.vue?vue&type=template&id=24b86e9e&scoped=true"
import script from "./MaterialBlock.vue?vue&type=script&lang=js"
export * from "./MaterialBlock.vue?vue&type=script&lang=js"

import "./MaterialBlock.vue?vue&type=style&index=0&id=24b86e9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b86e9e"]])

export default __exports__